import { Navigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const SuperAdminRoute = ({ children }) => {
  const location = useLocation();
  const userAttributes = useSelector((state) => state.auth.userAttributes);

  // Check if user is Business Admin
  const isSuperAdmin = userAttributes['custom:role'] === 'super_admin';

  if (!isSuperAdmin) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

SuperAdminRoute.propTypes = {
  children: PropTypes.node,
};
export default SuperAdminRoute;
